import React from "react";
import { ListSubheader, TextField, IconButton } from "@material-ui/core";
import Delete from "@material-ui/icons/Delete";

const SearchBar = ({ listHeader, searchVal, setSearchVal }) => (
  <ListSubheader
    style={{ backgroundColor: "white" }}
    component="div"
    id="nested-list-subheader"
  >
    {listHeader}
    <br />
    <TextField
      placeholder="Search here"
      margin="dense"
      value={searchVal}
      InputLabelProps={{ shrink: true }}
      onChange={(e) => {
        setSearchVal(e.target.value);
      }}
    />
    <IconButton
      onClick={() => {
        setSearchVal("");
      }}
      aria-label="search"
    >
      <Delete />
    </IconButton>
  </ListSubheader>
);

export default SearchBar;
